import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { LOGGED_HOME_PAGE_PATH } from "../../../../constants/env";
import { Loading } from "../../../../legacy/components/Loading";
import { getAdminRedirectUrl } from "../services/admin-redirect/admin-redirect";

export function AdminRedirectGuard(): JSX.Element {
  const { pathname, search } = useLocation();
  const adminRedirectUrl = getAdminRedirectUrl(pathname, search);

  useEffect(
    function redirectToExternalAdmin() {
      if (adminRedirectUrl) {
        window.location.replace(adminRedirectUrl);
      }
    },
    [adminRedirectUrl]
  );

  if (!adminRedirectUrl) {
    return <Navigate to={LOGGED_HOME_PAGE_PATH} replace />;
  }

  return <Loading />;
}

export default AdminRedirectGuard;
